export default {
  name: 'techLevel',
  key: 'techLevel',
  attributes: {
    TL0: { key: 'TL0', name: 'techLevel.0' },
    TL1: { key: 'TL1', name: 'techLevel.1' },
    TL2: { key: 'TL2', name: 'techLevel.2' },
    TL3: { key: 'TL3', name: 'techLevel.3' },
    TL4: { key: 'TL4', name: 'techLevel.4' },
    'TL4+': { key: 'TL4+', name: 'techLevel.4+' },
    TL5: { key: 'TL5', name: 'techLevel.5' },
  },
};
